import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { X } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import API from '../../api/api'
import ToggleField from '../FormLegacy/FormFieldsV2/ToggleField'
import Loader from '../Loader/Loader'

const SurveySettings = ({ buildingId, onClose }) => {
  const { t } = useTranslation(['surveys', 'common'])
  const [templatesStatus, setTemplatesStatus] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (buildingId) {
      API.getSurveyTemplatesStatus(buildingId)
        .then(({ data }) => setTemplatesStatus(data))
        .catch((err) => console.error(err))
    }
  }, [buildingId])

  const updateTemplates = (id) => {
    setTemplatesStatus((prev) =>
      prev.map((temp) => {
        if (temp.id === id) {
          return { ...temp, active: !temp.active }
        }
        return temp
      }),
    )
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await API.updateSurveyTemplatesStatus(buildingId, templatesStatus)
      onClose()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className="survey-settings-modal">
      <div className={`survey-settings-modal__container`}>
        <div className="window-header">
          <div className="left-side">
            <div className="title">{t('surveys:settingsModal.title')}</div>
          </div>
          <div className="right-side">
            <div className="navi-button" onClick={onClose}>
              <X size={20} />
            </div>
          </div>
        </div>
        {templatesStatus.length ? (
          <React.Fragment>
            <div className="main-view">
              {templatesStatus.map((temp) => (
                <ToggleField
                  key={temp.id}
                  label={temp.templateName}
                  id={temp.id}
                  name={temp.templateName}
                  onChange={() => updateTemplates(temp.id)}
                  value={templatesStatus.find((template) => template.id === temp.id).active}
                />
              ))}
            </div>
            <div className="footer-buttons">
              <button
                type="submit"
                className={`button button-grey is-block`}
                onClick={onClose}
                disabled={isLoading}
              >
                {t('surveys:settingsModal.cancel')}
              </button>
              <button
                type="submit"
                className={`button button-primary is-block ${isLoading ? 'is-loading' : ''}`}
                onClick={handleSubmit}
              >
                {t('surveys:settingsModal.save')}
              </button>
            </div>
          </React.Fragment>
        ) : isLoading ? (
          <div className="loader-container">
            <Loader />
          </div>
        ) : (
          <div className="no-data-container">{t('surveys:settingsModal.noData')}</div>
        )}
      </div>
    </div>
  )
}

SurveySettings.propTypes = {
  templatesStatus: PropTypes.array,
  buildingId: PropTypes.number,
  updateTemplates: PropTypes.func,
  onClose: PropTypes.func,
}

export default SurveySettings
